import { cloneDeep } from 'lodash'

import { get, set } from './util'

export function Cascader({ option, value, ref }) {
   
    return {
        data() {
            return {
                preData: []
            }
        },
        mounted() {
            const cascader = this.getCascader();
            cascader.$on('change', this.onCascaderChange);
        },
        methods: {
            getCascader() {
                return this.$refs[ref]
            },
            onCascaderChange(v) {
                const data = cloneDeep(get(this, option) || []);
                data.shift();
                // set(this, value, [['']]);
                const valusList =  []
                this.getAllData(data, undefined, valusList);
                const preData = cloneDeep(this.preData);
                if (v.length) {
                    const dataList = cloneDeep(v);
                    const hasAll = preData.find(v=> {
                        return v[0] === 'all'
                    })
                    if (dataList[0][0] === 'all') {
                        if (!hasAll) {
                            // 全选
                            set(this, value, [
                                ['all'],
                                ...valusList
                            ]);
                        }else {
                            dataList.shift();
                            // 取消全选
                            set(this, value, dataList);
                        }
                    }else {
                         if (hasAll) {
                            // dataList.shift();
                            // 取消全选
                            set(this, value, []);
                        }else {
                            if (valusList.length === dataList.length) {
                                set(this, value, [
                                    ['all'],
                                    ...valusList
                                ]);
                            }
                        }
                    };
                }
            },
            getAllData(list, values = [], data = []) {
                let arrs = [...values]
                list.forEach(v=>{
                    if (v.children&&v.children.length) {
                        arrs.push(v.value);
                        this.getAllData(v.children, arrs, data);
                    }else {
                        arrs.push(v.value);
                        data.push(arrs);
                    }
                    arrs = [...values]
                });
            }
        },
        watch: {
            [value](n, o) {
                this.preData = n
            },
            [option](n) {
                 // 如果是计算属性   就需要自行加入全部的 选项
                if (n&&n.length&&!this.$options.computed[option]) {
                    const first = n[0];
                    if (first.label !== '全选') {
                        const list = [
                            {
                                value: 'all',
                                label: '全选', 
                            },
                            ...n
                        ];
                        set(this, option, list )
                    }
                }
            }
        }
    }
};